import React, { useState } from "react";
import { useLanguage, type Language } from "@/contexts/LanguageContext";
import { useGames } from "@/hooks/useGames";
import { ChevronDown, ChevronUp, Gamepad2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { getGameCategoryPath } from "@/utils/i18nRouting";
import { OptimizedImage } from "@/components/OptimizedImage";

export const SEOContentSection: React.FC = () => {
  const { t, language } = useLanguage();
  const { data: games } = useGames();
  const [isExpanded, setIsExpanded] = useState(false);

  // Afficher TOUS les jeux pour un meilleur référencement SEO
  const popularGames = games || [];

  const content = {
    fr: {
      h1: "Top Serveurs Privés Gaming",
      h1Span1: "Classement des Meilleurs ",
      h1Span2: "Serveurs Privés Gaming",
      h1Span3: " - Vote en Temps Réel",
      intro:
        "Bienvenue sur RankServeur, la plateforme de référence pour le classement de serveurs de jeux. Découvrez, évaluez et rejoignez une communauté gamers passionnée à la recherche des meilleures expériences sur serveurs privés gaming. Notre mission est de fournir des classements fiables et transparents, propulsés par les votes des joueurs en temps réel.",
      h2FindServer: "Serveur Privé Populaire : Trouvez Votre Serveur Idéal",
      findServerDesc:
        "Que vous soyez un vétéran ou un nouveau joueur, notre plateforme de classement serveurs jeux est conçue pour vous aider à trouver le serveur privé populaire qui correspond parfaitement à votre style de jeu. Serveurs Minecraft, serveurs Dofus, serveurs WoW, serveurs GTA RP, serveurs CS2, serveurs Rust et bien plus encore.",
      h3GamesList: "Serveurs de Jeux Privés - Tous les Meilleurs Jeux Gaming",
      gamesListIntro: "Découvrez notre sélection complète de serveurs privés :",
      h2HowItWorks: "Classement Serveurs Jeux : Voter Serveurs Jeux en Temps Réel",
      howItWorksDesc:
        "Le top serveurs gaming de RankServeur est mis à jour en temps réel grâce à un système de vote communautaire. Chaque joueur peut voter serveurs jeux favoris, garantissant ainsi que notre classement reflète véritablement la popularité et la qualité des serveurs listés. Votre voix est essentielle pour aider la communauté gamers à faire le bon choix.",
      h3Discover: "Private Server Gaming : Top Serveurs Gaming par Catégorie",
      discoverDesc:
        "Naviguez facilement à travers notre sélection pour trouver les serveurs privés gaming les plus actifs et appréciés. Utilisez nos filtres pour affiner votre recherche : serveurs Minecraft moddés, serveur privé Dofus rétro, serveurs WoW vanilla, serveurs GTA RP français, serveurs CS2 compétitifs, serveurs Rust PvP. Le classement jeux en ligne est l'outil indispensable pour explorer de nouvelles communautés.",
      h4Join: "Ajouter Serveur Jeu : Rejoignez un Serveur Privé Populaire",
      joinDesc:
        "Des aventures épiques vous attendent sur les meilleurs serveurs privés gaming. La communauté gamers RankServeur vous guide vers les expériences de jeu les plus mémorables. Vous pouvez également ajouter serveur jeu gratuitement pour partager votre serveur avec la communauté.",
      toggleShow: "Afficher plus d'informations",
      toggleHide: "Masquer les informations",
    },
    en: {
      h1: "Top Private Gaming Servers",
      h1Span1: "Best ",
      h1Span2: "Private Gaming Servers",
      h1Span3: " Ranking - Real-Time Voting",
      intro:
        "Welcome to RankServeur, the reference platform for game server rankings. Discover, rate and join a passionate gamers community looking for the best private gaming server experiences. Our mission is to provide reliable and transparent rankings, powered by real-time player votes.",
      h2FindServer: "Popular Private Server: Find Your Ideal Server",
      findServerDesc:
        "Whether you're a veteran or a new player, our game server ranking platform is designed to help you find the popular private server that perfectly matches your play style. Minecraft servers, Dofus servers, WoW servers, GTA RP servers, CS2 servers, Rust servers and much more.",
      h3GamesList: "Private Game Servers - All Best Gaming Servers",
      gamesListIntro: "Explore our complete selection of private servers:",
      h2HowItWorks: "Game Server Ranking: Vote Gaming Servers in Real-Time",
      howItWorksDesc:
        "RankServeur's top gaming servers are updated in real-time thanks to a community voting system. Each player can vote gaming servers favorites, ensuring that our ranking truly reflects the popularity and quality of the listed servers. Your voice is essential to help the gamers community make the right choice.",
      h3Discover: "Private Server Gaming: Top Gaming Servers by Category",
      discoverDesc:
        "Easily navigate through our selection to find the most active and appreciated private gaming servers. Use our filters to refine your search: modded Minecraft servers, retro Dofus private server, vanilla WoW servers, French GTA RP servers, competitive CS2 servers, PvP Rust servers. The online game ranking is the essential tool to explore new communities.",
      h4Join: "Add Game Server: Join a Popular Private Server",
      joinDesc:
        "Epic adventures await you on the best private gaming servers. The RankServeur gamers community guides you to the most memorable gaming experiences. You can also add game server for free to share your server with the community.",
      toggleShow: "Show more information",
      toggleHide: "Hide information",
    },
    es: {
      h1: "Top Servidores Privados Gaming",
      h1Span1: "Clasificación de los Mejores ",
      h1Span2: "Servidores Privados Gaming",
      h1Span3: " - Votación en Tiempo Real",
      intro:
        "Bienvenido a RankServeur, la plataforma de referencia para la clasificación de servidores de juegos. Descubre, evalúa y únete a una comunidad gamers apasionada en busca de las mejores experiencias en servidores privados gaming. Nuestra misión es proporcionar clasificaciones confiables y transparentes, impulsadas por votos de jugadores en tiempo real.",
      h2FindServer: "Servidor Privado Popular: Encuentra Tu Servidor Ideal",
      findServerDesc:
        "Ya seas un veterano o un nuevo jugador, nuestra plataforma de clasificación servidores juegos está diseñada para ayudarte a encontrar el servidor privado popular que se adapte perfectamente a tu estilo de juego. Servidores Minecraft, servidores Dofus, servidores WoW, servidores GTA RP, servidores CS2, servidores Rust y mucho más.",
      h3GamesList: "Servidores de Juegos Privados - Todos los Mejores Servidores Gaming",
      gamesListIntro: "Explora nuestra selección completa de servidores privados:",
      h2HowItWorks: "Clasificación Servidores Juegos: Votar Servidores Juegos en Tiempo Real",
      howItWorksDesc:
        "El top servidores gaming de RankServeur se actualiza en tiempo real gracias a un sistema de votación comunitaria. Cada jugador puede votar servidores juegos favoritos, asegurando así que nuestra clasificación refleje verdaderamente la popularidad y calidad de los servidores listados. Tu voz es esencial para ayudar a la comunidad gamers a tomar la decisión correcta.",
      h3Discover: "Private Server Gaming: Top Servidores Gaming por Categoría",
      discoverDesc:
        "Navega fácilmente a través de nuestra selección para encontrar los servidores privados gaming más activos y apreciados. Usa nuestros filtros para refinar tu búsqueda: servidores Minecraft modded, servidor privado Dofus retro, servidores WoW vanilla, servidores GTA RP españoles, servidores CS2 competitivos, servidores Rust PvP. La clasificación juegos en línea es la herramienta indispensable para explorar nuevas comunidades.",
      h4Join: "Agregar Servidor Juego: Únete a un Servidor Privado Popular",
      joinDesc:
        "Aventuras épicas te esperan en los mejores servidores privados gaming. La comunidad gamers RankServeur te guía hacia las experiencias de juego más memorables. También puedes agregar servidor juego gratis para compartir tu servidor con la comunidad.",
      toggleShow: "Mostrar más información",
      toggleHide: "Ocultar información",
    },
  };

  const currentContent = content[language as keyof typeof content];

  return (
    <section className="w-full max-w-7xl mx-auto px-4 py-6">
      {/* Bouton toggle centré et visible */}
      <div className="flex justify-center mb-4">
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          variant="outline"
          className="flex items-center gap-2 hover:bg-primary/10 transition-all duration-300"
        >
          {isExpanded ? (
            <>
              <ChevronUp className="h-5 w-5" />
              {currentContent.toggleHide}
            </>
          ) : (
            <>
              <ChevronDown className="h-5 w-5" />
              {currentContent.toggleShow}
            </>
          )}
        </Button>
      </div>

      {/* Intro TOUJOURS visible pour l'indexation Google */}
      <div className="prose prose-invert max-w-none mb-4">
        <p className="text-sm text-muted-foreground leading-relaxed">{currentContent.intro}</p>
      </div>

      {/* Contenu SEO étendu avec animation de dépliement */}
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isExpanded ? "max-h-[3000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="prose prose-invert max-w-none">
          {/* H1 principal de la page d'accueil */}
          <h1 className="text-3xl font-bold mb-6 bg-gradient-to-r from-primary via-purple-400 to-pink-400 bg-clip-text text-transparent">
            <span>{currentContent.h1Span1}</span>
            <span className="underline decoration-primary/50">{currentContent.h1Span2}</span>
            <span>{currentContent.h1Span3}</span>
          </h1>

          {/* H2 - Trouver son serveur */}
          <h2 className="text-3xl font-semibold mb-4 text-foreground">{currentContent.h2FindServer}</h2>
          <p className="text-muted-foreground mb-6 leading-relaxed">{currentContent.findServerDesc}</p>

          {/* H3 - Liste des jeux */}
          <h3 className="text-2xl font-semibold mb-4 text-foreground">{currentContent.h3GamesList}</h3>
          <p className="text-muted-foreground mb-4">{currentContent.gamesListIntro}</p>

          {/* Liste dynamique de tous les jeux avec liens internes */}
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-8">
            {popularGames.map((game) => (
              <li key={game.id} className="list-none">
                <Link
                  to={getGameCategoryPath(language as Language, game.name)}
                  className="flex items-center gap-2 p-3 rounded-lg bg-card/50 hover:bg-card transition-all duration-300 border border-border/50 hover:border-primary/50"
                >
                  {game.logo_url && (
                    <OptimizedImage
                      src={game.logo_url}
                      alt={language === 'fr' ? `Logo officiel du jeu ${game.name}` : language === 'es' ? `Logo oficial del juego ${game.name}` : `Official ${game.name} game logo`}
                      imageType="logo"
                      width={32}
                      height={32}
                      loading="lazy"
                      className="w-8 h-8 rounded object-cover"
                      fallback={
                        <div className="w-8 h-8 rounded bg-slate-700 flex items-center justify-center">
                          <Gamepad2 className="w-4 h-4 text-gaming-primary" />
                        </div>
                      }
                    />
                  )}
                  <span className="font-medium text-foreground hover:text-primary transition-colors">{game.name}</span>
                </Link>
              </li>
            ))}
          </ul>

          {/* H2 - Comment ça marche */}
          <h2 className="text-3xl font-semibold mb-4 text-foreground">{currentContent.h2HowItWorks}</h2>
          <p className="text-muted-foreground mb-6 leading-relaxed">{currentContent.howItWorksDesc}</p>

          {/* H3 - Découvrir par catégorie */}
          <h3 className="text-2xl font-semibold mb-4 text-foreground">{currentContent.h3Discover}</h3>
          <p className="text-muted-foreground mb-6 leading-relaxed">{currentContent.discoverDesc}</p>

          {/* H4 - Rejoindre un serveur */}
          <h4 className="text-xl font-semibold mb-4 text-foreground">{currentContent.h4Join}</h4>
          <p className="text-muted-foreground leading-relaxed">{currentContent.joinDesc}</p>
        </div>
      </div>
    </section>
  );
};
